/**
 * The Requests board «لوحة الطلبات» (/advertisements): custom real-estate
 * requests that professional accounts post and answer. The board is for
 * professional accounts only, reading included.
 * Used through useTranslation(['ads', 'gating']).
 */
const ads = {
  title: 'Requests board',
  subtitle:
    'Post a custom real-estate request, such as building a school in a given district, for brokers, companies, developers and real-estate professionals to answer.',
  post: 'Post a request',
  cancel: 'Cancel',

  form: {
    heading: 'New request',
    title: 'Request title',
    titlePlaceholder: 'e.g. Land for building a school',
    titleHint: 'A short title for your request, at least 3 characters.',
    titleTooShort: 'Write a title of at least 3 characters.',
    body: 'Request details',
    bodyPlaceholder: 'Location, size, budget, timing and any other conditions.',
    bodyHint: 'The clearer the details, the more precise the replies.',
    bodyTooShort: 'Write details of at least 5 characters.',
    category: 'Category (optional)',
    categoryPlaceholder: 'e.g. Land, development, investment',
    submit: 'Publish request',
    published: 'Your request is now on the board.',
  },

  list: {
    heading: 'Open requests',
    loading: 'Loading requests…',
    empty: 'There are no open requests right now.',
    emptyHint: 'Post the first one, and professional accounts will see it here.',
    replies: 'Replies: {{n}}',
    yours: 'Your request',
  },

  detail: {
    loading: 'Loading replies…',
    loadError: "Couldn't load the replies.",
    repliesHeading: 'Replies',
    noReplies: 'No replies yet.',
    yourReply: 'Your reply',
    replyLabel: 'Write a reply',
    replyPlaceholder: 'Write your reply to this request…',
    send: 'Send',
    replySent: 'Your reply was sent.',
    closePost: 'Close request',
    closeConfirm: "Close this request? It will leave the board and won't take new replies.",
    closeYes: 'Yes, close it',
    closeNo: 'Keep it open',
    closed: 'The request was closed.',
  },

  errors: {
    disabled: "The requests board isn't enabled yet.",
    load: "Couldn't load the requests board. Check your connection and try again.",
    post: "Couldn't post your request. Please try again.",
    invalid: 'Check the title and details, then try again.',
    reply: "Couldn't send your reply. Please try again.",
    replyClosed: 'This request is closed and no longer takes replies.',
    notFound: 'This request is no longer available.',
    close: "Couldn't close the request. Please try again.",
    notOwner: 'Only the person who posted a request can close it.',
    retry: 'Try again',
  },

  session: {
    title: 'Your session has ended',
    body: 'Sign in again to continue with the requests board.',
    signIn: 'Sign in',
  },
};

export default ads;
